import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';
import {useHttpMonitorPause} from 'features/http/model/useHttpMonitorMutations';

interface IHttpMonitorPauseModalProps {
    item: IHttpMonitorOutput,
    open: boolean;
    handleClose: () => void;
}

const HttpMonitorPauseModal: React.FC<IHttpMonitorPauseModalProps> = ({ item, open, handleClose }) => {
    const {pause, isLoading} = useHttpMonitorPause({item, handleClose});

    return (
        <ConfirmModal
            variant="pause"
            open={open}
            handleClose={handleClose}
            header={t`Приостановка монитора`}
            title={<Trans id="modal.monitor.pausa.title" message="Вы уверены, что хотите приостановить монитор"/>}
            name={item.name || item.url}
            confirmText={t`Приостановить`}
            onConfirm={pause}
            isLoading={isLoading}
        />
    );
};

export default HttpMonitorPauseModal;
